import _ from 'lodash';

class ParallaxScroll {
    constructor(options = {}) {
        this.options = {
            sectionSelector: '',
            backgroundSelector: '',
            speed: 1,
            ...options
        };

        this.sections = document.querySelectorAll(this.options.sectionSelector);
        this.handleScroll = this.handleScroll.bind(this);

        // Throttle the handleScroll method to limit how often it runs
        this.throttledScroll = _.throttle(this.handleScroll, 2);

        if (this.sections.length) {
            this.init();
        }
    }

    init() {
        // Add the throttled scroll event listener
        window.addEventListener('scroll', this.throttledScroll);
        // Call handleScroll once to apply the effect initially
        this.handleScroll();
    }

    handleScroll() {
        this.sections.forEach(section => {
            const background = section.querySelector(this.options.backgroundSelector);
            if (background) {
                // Calculate the parallax effect's translateY value
                const translateY = -(window.scrollY * this.options.speed);
                background.style.transform = `translateY(${translateY}px)`;
            }
        });
    }

    destroy() {
        // Remove the throttled scroll event listener
        window.removeEventListener('scroll', this.throttledScroll);
    }
}

function initParallaxScroll(userOptions = {}) {
    return new ParallaxScroll(userOptions);
}

// Initialize the parallax effect once the DOM is ready
// document.addEventListener('DOMContentLoaded', () => {
    // console.log('DOM fully loaded and parsed.');
    const parallaxInstance = initParallaxScroll({
        sectionSelector: '.b-hero__standard.layout-1',
        backgroundSelector: '.b-hero__standard__background',
        speed: -0.5
    });
// });
